import { useMutation } from '@tanstack/react-query';
import { useDispatch, useSelector } from '@s20/hooks/redux.hooks';
import { useTranslation } from '@s20/i18n';
import { getUser } from '@s20/selectors/features/common.selectors';
import { setUser } from '@s20/slices/features/common.slice';
import { httpClient } from '@s20/services/httpClient';
import { InfoCheckbox } from '../../common/forms/InfoCheckbox';
import { toasty } from '../../common/forms/FormElements';
import { ApiRoutes } from '../../Common';

export const OnCallAvailability = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const user = useSelector(getUser);

    const { mutate: updateOnCallStatus, isPending } = useMutation({
        mutationFn: (next) => httpClient.put(
            ApiRoutes.auth.updateFlaggerOnCallStatus(),
            { isFlaggerAvailableForOnCall: next },
        ),
        onSuccess: (_data, next) => {
            dispatch(setUser({ ...user, isFlaggerAvailableForOnCall: next }));
            toasty.success(t('employee:onCallAvailabilitySaved'));
        },
        onError: (err) => {
            console.error({ err });
            // A restricted employee can't make themselves available (enforced server-side).
            // The only handled error this endpoint returns is that restriction.
            toasty.error(err?.handledError
                ? t('employee:onCallRestrictedMessage')
                : t('employee:onCallAvailabilitySaveError'));
        },
    });

    if (!user?.employeeId || user.excludeDispatch || !user.isFieldGroupMember) {
        return null;
    }

    return (
        <div className="dashboard-oncall-banner">
            <InfoCheckbox
                id="flaggerOnCall"
                name="flaggerOnCall"
                className="mt-4"
                color="info"
                label={t('employee:onCallAvailabilityLabel')}
                tooltip={user.isOnCallRestricted ? t('employee:onCallRestrictedMessage') : undefined}
                checked={Boolean(user.isFlaggerAvailableForOnCall)}
                disabled={isPending || user.isOnCallRestricted}
                onChange={(e) => updateOnCallStatus(e.target.checked)}
            />
        </div>
    );
};
